<script>
    import { fade } from 'svelte/transition';
    import { flip } from 'svelte/animate';
    import {link , push} from 'svelte-spa-router'
    import { fetchDataApps } from '../../api.js';
    import UserStore from '../../stores/user.js';
    import { _ } from "svelte-i18n";
    import { onMount , onDestroy } from 'svelte';
    import Header from '../../components/Header.svelte';
    import TopInfo from '../../components/TopInfo.svelte';  
    import Preloader from '../../components/Preloader.svelte'; 


    export let params;

    let view_id = params.view_id

    let isLoading = false; 
    
    let products = [];
    let name = '';
    let startDate = '';
    let endDate = '';
    let priority = '';
    let active = false;
    let view_default = false;
    
    onMount(async() => {

        if (!$UserStore || !$UserStore.data){
            push('/login');
            return;
        }
        
        isLoading = true;

        let postData = {
            action : 'get_product_view',
            token : $UserStore.data,
            view_id
        };
        let data = await fetchDataApps(postData);
        products = data.products;
        name = data.view.view_name;
        startDate = data.view.start_datetime;
        endDate = data.view.end_datetime;
        priority = data.view.priority;
        active = data.view.active;
        view_default = data.view.default;

        isLoading = false; 
      
    })




    async function saveView() {
        isLoading = true;

        const cleanedProducts = products.map(p => {
            const { variants, product_options, image, ...rest } = p; // Remove the variants field
            return rest;
        });

        console.log('cleanedProducts',cleanedProducts)


        let postData = {
            action : 'save_products_view',
            token : $UserStore.data,
            view_id,
            products : JSON.stringify(cleanedProducts),
            name,
            startDate,
            endDate,
            priority,
            active,
            view_default
        };
        let data = await fetchDataApps(postData);
        
        products = data.products;
        isLoading = false; 
    }

    let draggedIndex = null;
    let dropTargetIndex = null;
    let selectedIds = [];

    function toggleSelect(id) {
        if (selectedIds.includes(id)) {
            selectedIds = selectedIds.filter((i) => i !== id);
        } else {
            selectedIds = [...selectedIds, id];
        }
    }

    function handleDragStart(index) {
        draggedIndex = index;

        // Auto-select the dragged item if nothing is selected
        const draggedId = products[index]?.id;
        if (!selectedIds.includes(draggedId)) {
            selectedIds = [draggedId];
        }
    }

    function handleDragEnter(index) {
        if (draggedIndex !== null && index !== draggedIndex) {
            dropTargetIndex = index;
        }
    }

    function handleDragOver(event) {
        event.preventDefault();
    }

    function handleDrop(index) {
        if (draggedIndex === null || index === draggedIndex) return;
        moveItem(draggedIndex, index);
        draggedIndex = null;
        dropTargetIndex = null;
    }

    function handleDragEnd() {
        draggedIndex = null;
        dropTargetIndex = null;
    }


    function moveItem(fromIndex, toIndex) {
        const updated = [...products];

        // Get selected items and preserve their order in the original array
        const selectedItems = products.filter(p => selectedIds.includes(p.id));

        // Remove selected items from the array
        const filtered = updated.filter(p => !selectedIds.includes(p.id));

        // Calculate new drop index relative to the filtered array
        let insertIndex = toIndex+1;

        // If we're dragging downwards (to a later index), the removal of items above it shifts the index
        const indexesOfRemoved = products
            .map((p, i) => selectedIds.includes(p.id) ? i : null)
            .filter(i => i !== null);

        const itemsAbove = indexesOfRemoved.filter(i => i < toIndex).length;
        insertIndex = insertIndex - itemsAbove;

        // Insert selected items at the new index
        filtered.splice(insertIndex, 0, ...selectedItems);

        // Reassign updated list and fix positions
        products = filtered.map((item, index) => ({
            ...item,
            position: index + 1,
        }));

        selectedIds = [];
    }

    function moveToPosition(index, posInput) {
        let toIndex = parseInt(posInput) - 1;
        if (toIndex > products.length) {
            toIndex = products.length;
        }
        if (!isNaN(toIndex) && toIndex >= 0 && toIndex < products.length && toIndex !== index) {
            moveItem(index, toIndex);
        }
    }

    function duplicateItem(item) {
        const index = products.findIndex(p => p.id === item.id);
        const copy = {
            ...item,
            id: crypto.randomUUID(),
            name: item.name,
        };

        const updated = [...products];
        updated.splice(index + 1, 0, copy); // insert right after original

        // Recalculate positions
        products = updated.map((p, i) => ({ ...p, position: i + 1 }));
    }

    function hideItem(item) {
        products = products.map(p =>
            p.id === item.id ? { ...p, visible: !p.visible } : p
        );
    }

    function deleteItem(item) {
        if (!confirm("Are you sure you want to delete this item?")) {
            return;
        }
        products = products.map(p =>
            p.id === item.id ? { ...p, deleted: !p.deleted } : p
        );
    }

    function updateImage(item) {

        const selectedVariant = item.variants.find(v => v.base_variant_id === item.variant_id);
        if (selectedVariant && selectedVariant.image) {
            item.image = selectedVariant.image;
        }
    }


</script>


<style>


    .item {
        padding: 1px;
        border: 2px solid #ccc;
        background: white;
        cursor: grab;
        display: flex;
        flex-direction: column;
        gap: 5px;
        transition: transform 0.15s ease;
        width: 200px;;
    }
    .item img {
        width: 200px;;
    }
    .item.item-blur {
        opacity: 0.5;
    }
    .item.item-deleted {
        border-color: red;
    }

    .item.dragging {
        /* transform: scale(0.95); */
    }

    .drop-target {
        border-left: 2px solid var(--theme-one-color);
        background: #e0f0ff;
        height: 100%;
        width: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
    }




    .small_button_chav {
        border-radius: 10px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        
    }

    .position-input {
        border-end-end-radius: 0;
        border-start-end-radius: 0;
    }



</style>


<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">
        <TopInfo />
        <div class="dash-list">
            <div class="w-full items-end justify-between mb-[50px]">
                <h1>{$_('merchandiser.view')}</h1> 

                <div class="form flex gap-2 mt-4 align-center mb-[30px]">
                    
                    <div class="input_box flex-col gap-[10px]">
                        <label for="active">{$_('merchandiser.active')}</label>
                        <div class="input_con radio checkbox-toggle w-[50px] !mt-0">
                            <input id="active" type="checkbox" bind:value={active} bind:checked={active} />
                            <label for="active"><span></span></label>
                        </div>
                    </div>  
                    
                    <!-- <div class="input_box flex-col gap-[10px]">
                        <label for="active">Default</label>
                        <div class="input_con radio checkbox-toggle w-[50px] !mt-0">
                            <input id="view_default" type="checkbox" bind:value={view_default} bind:checked={view_default} />
                            <label for="view_default"><span></span></label>
                        </div>
                    </div>   -->

                    <div class="input_con">
                        <label for="name">{$_('merchandiser.name')}</label>
                        <input id="name" type="text" bind:value={name} class="border p-2 rounded w-full" />
                    </div>
                  
                    <div class="input_con">
                        <label for="start">{$_('merchandiser.startDate')}</label>
                        <input id="start" type="datetime-local" bind:value={startDate} class="border p-2 rounded w-full" />
                    </div>
                  
                    <div class="input_con">
                        <label for="end">{$_('merchandiser.endDate')}</label>
                        <input id="end" type="datetime-local" bind:value={endDate} class="border p-2 rounded w-full" />
                    </div>
                  
                    <div class="input_con">
                        <label for="priority">{$_('merchandiser.priority')}</label>
                        <input id="priority" type="text" bind:value={priority} class="border p-2 rounded w-[50px]" />
                    </div>                    
                    
                </div>
                
                <div class="items flex-wrap w-full flex gap-2">
                    {#each products as item, index (item.id)}                            

                        <div
                            class="flex gap-2 {index === draggedIndex ? 'dragging' : ''}"
                            draggable="true"
                            on:dragstart={() => handleDragStart(index)}
                            on:dragenter={() => handleDragEnter(index)}
                            on:dragover={handleDragOver}
                            on:drop={() => handleDrop(index)}
                            on:dragend={handleDragEnd}  
                            animate:flip={{ duration: 150 }}                      
                            transition:fade
                            >                                
                            <div class="item relative {item.visible ? '' : 'item-blur'} {item.deleted ? 'item-deleted' : ''}">  
                                <div class="input_box gap-[10px] absolute t-[10px] w-full justify-between">
                                    <div class="input_con checkbox-toggle w-[50px] !mt-0 p-2">
                                        <input class="w-[20px]" id="itemchecked{item.id}" type="checkbox" checked={selectedIds.includes(item.id)}
                                        on:change={() => toggleSelect(item.id)} />
                                        <label for="itemchecked{item.id}"><span></span></label>
                                    </div>
                                    <div class="flex flex-col gap-1 jusify-end items-end p-2 text-slate-600">
                                        <div class="flex flex-col justify center">
                   
                                            <button 
                                            class="tooltip-btn" 
                                            title="Duplicate" 
                                            on:click={() => duplicateItem(item)}
                                            >
                                            <i class="fa-solid fa-clone"></i>
                                            </button>
                                        
                     
                                            <button 
                                            class="tooltip-btn" 
                                            title="Hide" 
                                            on:click={() => hideItem(item)}
                                            >
                                            <i class="fa-solid fa-eye-slash"></i>
                                            </button>
                                        
              
                                            <button 
                                            class="tooltip-btn" 
                                            title="Delete" 
                                            on:click={() => deleteItem(item)}
                                            >
                                            <i class="fa-solid fa-trash"></i>
                                            </button>
                                        </div>
                                      </div>
                                </div>                                  
                                <div><img src={item.image} alt={item.name} /></div>
                                <div class="p-[10px] flex flex-col gap-2">
                                    <div>{item.name} </div>
                                    <div class="flex gap-2 justify-between">
                                        <div>מחיר: {item.price}</div>                                    
                                        <div>
                                            כמות:
                                            {#if item.variants}
                                                {item.variants.reduce((sum, variant) => sum + variant.quantity, 0)}
                                            {:else}
                                                {item.quantity}
                                            {/if}
                                            </div>
                                    </div>
                                    <div class="product_options text-[12px]">
                                        <select class="px-1" bind:value={item.variant_id} on:change={() => updateImage(item)}>
                                            {#each item.variants as variant}
                                            <option value="{variant.base_variant_id}">
                                                {variant.sku} : 
                                                {#each variant.product_options as option}
                                                    {option.name} - {option.value}                                     
                                                {/each}
                                                (כמות:{variant.quantity})
                                            </option>
                                            {/each}
                                        </select>
                                    </div>
                                    <div class="flex text-[12px]">
                                        <input class="position-input py-[5px]" type="number" bind:value={item.position} min="1" max={products.length} />
                                        <button class="small_button small_button_chav w-[50px] p-[5px]" on:click={() => moveToPosition(index, item.position)}><i class="fa-solid fa-chevron-left"></i></button>
                                    </div>
                                </div>
                            </div>
                            {#if index === dropTargetIndex && index !== draggedIndex}
                            <div class="drop-target"></div>
                            {/if}
                        </div>

                    {/each}

                </div>
            </div>       
            <div class="shipment-flex-button fixed bottom-[20px] z-20 left-0 right-0 m-auto">
                <div class="create_button box-shadow" on:click={() => saveView() }>{$_('settings.save')}</div>
            </div>      
        </div>
    </div>
</div>